import React from 'react';
import { LockIcon, MonitorSmartphoneIcon, ShieldCheckIcon } from 'lucide-react';
const trust = [[MonitorSmartphoneIcon, 'Digital Access'], [LockIcon, 'Secure Payment'], [ShieldCheckIcon, '7-Day Guarantee']] as const;
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-navy/10 bg-white/95 shadow-sm backdrop-blur" data-id="element-220" data-mp="1y5n9qc3l4r8e">
      <div className="bg-navy px-3 py-2 text-center font-display text-[10px] font-extrabold uppercase tracking-[.12em] text-white sm:text-xs" data-id="element-221" data-mp="1t726e3t1drfq">
        Professional rehabilitation exercise system for coaches, trainers & active adults
      </div>
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-3 px-3 py-1.5 text-[10px] font-semibold uppercase text-steel sm:gap-6 sm:text-xs" data-id="element-222" data-mp="2h1mv34224wj0">
        {trust.map(([Icon, label], index) => <React.Fragment key={label} data-id="element-223" data-mp="39jr2xg2cmbce" data-mpi={index}>
            {index > 0 && <span className="text-brand" aria-hidden="true" data-id="element-224" data-mp="34rqwr5voqm7d">
                •
              </span>}
            <span className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-225" data-mp="26aj453ucts3">
              <Icon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-226" data-mp="67cl2tp57jxr" /> {label}
            </span>
          </React.Fragment>)}
      </div>
    </header>;
}